export default{
    "languages": [
      {
        "code": "en",
        "label": "English",
        "active": true
      },
      {
        "code": "hi",
        "label": "Hindi",
        "active": true
      },
      {
        "code": "mr",
        "label": "Marathi",
        "active": true
      },
      {
        "code": "ta",
        "label": "Tamil",
        "active": true
      },
      {
        "code": "te",
        "label": "Telugu",
        "active": true
      },
      {
        "code": "kn",
        "label": "Kannada",
        "active": true
      },
      {
        "code": "gu",
        "label": "Gujarati",
        "active": true
      },
      {
        "code": "pa",
        "label": "Punjabi",
        "active": true
      },
      {
        "code": "bn",
        "label": "Bengali",
        "active": true
      },
      {
        "code": "ml",
        "label": "Malayalam",
        "active": true
      },
      {
        "code": "as",
        "label": "Assamese",
        "active": true
      },
      {
        "code": "brx",
        "label": "Bodo",
        "active": true
      },
      {
        "code": "doi",
        "label": "Dogri",
        "active": true
      },
      {
        "code": "ks",
        "label": "Kashmiri",
        "active": true
      },
      {
        "code": "mai",
        "label": "Maithili",
        "active": true
      },
      {
        "code": "mni",
        "label": "Manipuri",
        "active": true
      },
      {
        "code": "ne",
        "label": "Nepali",
        "active": true
      },
      {
        "code": "or",
        "label": "Odia",
        "active": true
      },
      {
        "code": "sd",
        "label": "Sindhi",
        "active": true
      },
      {
        "code": "si",
        "label": "Sinhala",
        "active": true
      },
      {
        "code": "ur",
        "label": "Urdu",
        "active": true
      },
      {
        "code": "sat",
        "label": "Santali",
        "active": true
      },
      {
        "code": "sa",
        "label": "Sanskrit",
        "active": true
      },
      {
        "code": "gom",
        "label": "Goan Konkani",
        "active": true
      }
    ]
  }